import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '../store/index'
// import { getToken } from './auth'

window.localStorage.baseURL = process.env.BASE_URL
// 创建axios实例
const service = axios.create({
  baseURL: window.localStorage.baseURL, // api的base_url
  timeout: 30000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  const loginInfo = JSON.parse(localStorage.getItem('operateLoginInfo')) || {}
  if (!config.data) {
    config.data = {}
  }
  config.data.common = {
    apiVer: loginInfo.apiVer || 1,
    platformId: loginInfo.platformId || 6,
    requestId: loginInfo.requestId || Date.now(),
    token: loginInfo.token,
    uuid: loginInfo.uuid || '',
    packageName: 'web',
    versionCode: 1,
    versionName: '1.0',
    langCode: localStorage.getItem('LOCALE_KEY') || 'zh-cn'
  }
  return config
},
  error => {
    console.log(error) // for debug
  }
)

// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 10402 || res.code === -3 || res.code === '-3') {
      MessageBox.alert('登录信息过期，请重新登录', '提示信息', {
        confirmButtonText: '确定',
        callback: action => {
          store.dispatch('LoginOut').then(res => {
            location.reload()
          })
        }
      })
      return res
    } else if (res.code === 20000) {
      return res
    } else {
      Message({
        showClose: true,
        message: res.msg || '服务器异常',
        type: 'error'
      })
      return res
    }
  },
  error => {
    Message({
      message: '网络超时，请稍后重试',
      type: 'error'
    })
    console.error('err' + error)
    return {
      code: -20000
    }
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/sys_fetch.js